
import NewComponent from "../../../components/add_balance_records/New.vue";

export default {
  components: {
    NewComponent
  }
};
